import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { Challenge } from '@/contracts/system-modules/auth/dto/challenge/Challenge'
import { CreateChallengeParams } from '@/system-modules/auth/v1/api/v1/auth/CreateChallenge/Dto/CreateChallengeParams'

export class CreateChallengeRoute extends AuthRoute<CreateChallengeParams, Challenge> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/challenge'
  }

  offline(params: CreateChallengeParams): Promise<ApiResponse<Challenge>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new Challenge({
        challenge: 'offline-challenge-' + params.publicKey.slice(0, 8),
        expiresAt: new Date(Date.now() + 60000).toISOString(),
      }),
    }))
  }
}
